import { Link } from 'react-router-dom';
import { categories } from '@/mocks/siteData';

export default function CategoryNav() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            内容分类导航
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto">
            按分类浏览感兴趣的内容，快速找到你想要的精彩
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-5 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center mb-3 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${cat.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 transition-colors duration-300 whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}